export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtAQMAAAAUQe44AAAAA1BMVEXrV1cCOA1fAAAADklEQVQoz2MYBaOAGgAAAkkAAQmr4rUAAAAASUVORK5CYII="